export const getAccessToken = () => {
    try {
        const tokenModel = JSON.parse(localStorage.getItem('accessToken'));
        if (tokenModel) {
            return tokenModel;
        }
    } catch (ignore) {
    }
    return null;
};

export const setAccessToken = (tokenModel) => {
    if (!tokenModel) {
        localStorage.removeItem('accessToken');
    } else {
        try {
            localStorage.setItem('accessToken', JSON.stringify(tokenModel));
        } catch (ignore) {
            localStorage.removeItem('accessToken');
        }
    }
};



// WEBPACK FOOTER //
// ./src/utils/User.js